import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatSidenavHelperService,
  ViewTitleService,
  HttpRequestsService,
  HttpResponseHandleService,
  AnimationsService,
  SnipcartService,
  TranslateAiService,
} from '@shared/services';

import { CaseService } from '@core/node-systems/case/case.service';

export function provideViewTitleHandler(viewTitle: ViewTitleService): () => void {
  return () => {
    // Subscribe to view title changes and update the document title.
    viewTitle.title.subscribe((title) => {
      document.title = title ? `Viven Health - ${title}` : 'Viven Health';
    });
  };
}

@NgModule({
  imports: [BrowserAnimationsModule],
  exports: [BrowserAnimationsModule],
  providers: [
    MatSidenavHelperService,
    HttpRequestsService,
    ViewTitleService,
    HttpResponseHandleService,
    AnimationsService,
    SnipcartService,
    TranslateAiService,
    CaseService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import it in the AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,

      // These services are only going to be created once (one instance for the entire app),
      // not per module import.
      providers: [
        provideAppInitializer(() => {
          const initializerFn = provideViewTitleHandler(inject(ViewTitleService));
          return initializerFn();
        }),
      ],
    };
  }
}
